import Shimmer from "@/components/Shimmer";
import { useTranslation } from "react-i18next";
import { tv } from "tailwind-variants";

const styles = tv({
  slots: {
    tableWrapper: "shadow-md",
    table: "w-full",
    thead: "border-t border-gray",
    th: "px-20 py-10 text-left",
    tbody: "",
    tr: "border-y border-gray even:bg-gray-light/50",
    td: "px-20 py-10",
  },
});

interface IProps {
  phoneNumbers: IPhoneNumbersHealthCheck[];
  isLoading: boolean;
}

const PhoneNumbersTable = ({ phoneNumbers, isLoading }: IProps) => {
  const { t } = useTranslation();

  const {
    tableWrapper,
    table: tableContainer,
    thead,
    th,
    tbody,
    tr,
    td,
  } = styles();

  const renderStatus = (status: boolean) => (
    <>
      {status
        ? t("sms.healthCheck.doubleOptIn.phoneNumbers.active")
        : t("sms.healthCheck.doubleOptIn.phoneNumbers.inactive")}
    </>
  );

  const renderCountry = ({
    countryName,
    flag,
  }: {
    countryName: string;
    flag: string;
  }) => (
    <div className="flex flex-row gap-10">
      <span>{flag}</span>
      <div className="font-bold">{countryName}</div>
    </div>
  );

  if (isLoading) return <Shimmer height={340} width={309} />;

  return (
    <div className="max-w-full md:max-w-[340px]">
      <div className={tableWrapper()}>
        <table role="table" className={tableContainer()}>
          <thead className={thead()} data-testid="table-head">
            <tr>
              <th className={th()} role="cell">
                {t(
                  "sms.healthCheck.doubleOptIn.phoneNumbers.tableHeaders.country",
                )}
              </th>
              <th className={th()} role="cell">
                {t(
                  "sms.healthCheck.doubleOptIn.phoneNumbers.tableHeaders.status",
                )}
              </th>
            </tr>
          </thead>
          <tbody className={tbody()} data-testid="table-body">
            {phoneNumbers?.map(({ countryName, status, flag }, i) => (
              <tr key={i} className={tr()} data-testid="table-row">
                <td className={td()} role="cell">
                  {renderCountry({ countryName, flag })}
                </td>
                <td className={td()} role="cell">
                  {renderStatus(status)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PhoneNumbersTable;
